module.exports = __webpack_public_path__ + "img/Intro-Bg.5cb20e5.png";